<template>
    <div
        class="a-filterLabel"
        :style="[
            {
                color:
                    backgroundColor && !color
                        ? 'var(--color-primary)'
                        : color
                        ? color
                        : ''
            },
            { backgroundColor: backgroundColor }
        ]"
    >
        <span v-html="text"></span>
        <a-icon
            v-if="close"
            @click.native="$emit('close')"
            class="ml-2 mr-0"
            width="16px"
            height="16px"
            icon="Close"
            style="min-width: 16px"
        />
    </div>
</template>

<script>
export default {
    name: 'FilterLabel',
    props: {
        text: {
            type: String,
            required: true
        },
        close: {
            type: Boolean,
            default: true
        },
        backgroundColor: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.a-filterLabel {
    min-width: 55px;
    font-size: var(--font-size-tiny);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px 12px;
    color: #fff;
    background-color: var(--color-dark);
    line-height: 1;
    border-radius: 30px;
    transition: var(--transition);

    span {
        max-width: 170px;
        @include media-breakpoint-up(sm) {
            max-width: 180px;
        }
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        font-weight: 500;
        line-height: 1.2;
    }

    &:hover {
        opacity: 0.9;
    }
}
</style>
